// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kqsR","colBig":"styles_colBig__25b8a","colSmall":"styles_colSmall__3x1Zj","shopifyNameWrapper":"styles_shopifyNameWrapper__1tiMU"};